export const CREATE_MENU = 'CREATE_MENU'
export const GET_MENUS_DATA = 'GET_MENUS_DATA'
export const SET_MENUS_DATA = 'SET_MENUS_DATA'
export const SET_MENUS_PROCESSING = 'SET_MENUS_PROCESSING'
export const CREATE_MENU_SUCCESS = 'CREATE_MENU_SUCCESS'

export function getMenusData (payload = {}) {
  return {
    type: GET_MENUS_DATA,
    payload,
  }
}

export function setMenusData (payload = {}) {
  return {
    type: SET_MENUS_DATA,
    payload,
  }
}

export function setMenusProcessing (processing = true) {
  return {
    type: SET_MENUS_PROCESSING,
    payload: { processing },
  }
}

export function createNewMenu (payload = {}) {
  return {
    type: CREATE_MENU,
    payload,
  }
}

export function createMenuSuccess (payload = {}) {
  return {
    type: CREATE_MENU_SUCCESS,
    payload,
  }
}
